/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import {
  ApiResponse,
  DocumentUrlData,
  ImageUrlData,
  RemovePayload,
} from "models";
import brandApi from "api/brand";
import { BrandPayload, BrandSubmitForm, UpdateBrandStatus } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import brandLocationApi from "api/brandLocationApi";
// import { brandLocationActions } from "./brandLocationSlice";
import { BrandList, BrandLocations } from "models/brandLocation";
import documentApi from "api/document";
import { DocumentForm, StoreList } from "models/document";
import adminManageApi from "api/adminManage";
import { adminManageActions } from "./adminManageSlice";
import {
  AdminUsersPayload,
  adminUserForm,
  updateAdminUserForm,
} from "models/adminManage";
// import BrandLocationAction from "../components/action";

function* getAdminUsers(action: PayloadAction<AdminUsersPayload>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.getAdminUsersList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminManageActions.getAdminUsersSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminManageActions.getAdminUsersFailed(errorData));
  }
}

function* getAdminUserById(action: PayloadAction<AdminUsersPayload>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.getAdminUsersById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminManageActions.getAdminUserByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminManageActions.getAdminUserByIdFailed(errorData));
  }
}

function* addAdminUser(action: PayloadAction<adminUserForm>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.addAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminManageActions.addAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminManageActions.addAdminUserFailed(errorData));
  }
}

function* updateAdminUser(action: PayloadAction<updateAdminUserForm>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.updateAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminManageActions.updateAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminManageActions.updateAdminUserFailed(errorData));
  }
}

function* deleteAdminUser(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.deleteAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminManageActions.deleteAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminManageActions.deleteAdminUserFailed(errorData));
  }
}

function* getStoreListData(action: PayloadAction<StoreList>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.storeListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminManageActions.getStoreListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminManageActions.getStoreListFailed(errorData));
  }
}

function* getProfileUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      adminManageApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminManageActions.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminManageActions.getImageUrlFailed(errorData));
  }
}

function* getRoleListData(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(adminManageApi.getRoleList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminManageActions.getRoleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminManageActions.getRoleListFailed(errorData));
  }
}

export default function* adminManageSaga() {
  yield takeLatest(adminManageActions.getAdminUsers.type, getAdminUsers);
  yield takeLatest(adminManageActions.getAdminUserById.type, getAdminUserById);
  yield takeLatest(adminManageActions.addAdminUser.type, addAdminUser);
  yield takeLatest(adminManageActions.updateAdminUser.type, updateAdminUser);
  yield takeLatest(adminManageActions.deleteAdminUser.type, deleteAdminUser);
  yield takeLatest(adminManageActions.getStoreList.type, getStoreListData);
  yield takeLatest(adminManageActions.getRoleList.type, getRoleListData);
  yield takeLatest(adminManageActions.getImageUrl.type, getProfileUrl);
  //   yield takeLatest(documentActions.getCustomerList.type, getCustomerListData);
}
